/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React from "react";

import { activateUser } from "../../actions/auth/authAction";
import SweetAlert from "sweetalert2-react";

import queryString from "query-string";
import { connect } from "react-redux";

import LoadingIndicator from "../../shared/components/LoadingIndicator";

class Activateuser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    const queryParams = queryString.parse(this.props.location.search);

    this.props.activateUser({
      activation: queryParams.activation,
      email: queryParams.email.replace(" ", "+"),
    });
  }
  render() {
    const { auth } = this.props;

    if (auth.loading) {
      return <LoadingIndicator />;
    } else if (auth.error) {
      this.props.history.push("/login");
    }

    return (
      <SweetAlert
        title="Email verified!"
        confirmButtonColor=""
        show={true}
        text="Your e-mail address has been successfully verified"
        type="success"
        onConfirm={() => this.props.history.push("/")}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.login,
});

const mapDispatchToProps = (dispatch) => {
  return {
    activateUser: (userData) => activateUser(userData, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Activateuser);
